import React from 'react';
import {StyleSheet, View} from 'react-native';
import {Typography, Icon} from 'src/components';
import {colors} from 'src/assets';
import LocalText from 'src/local';

export type Props = {};

const Index: React.FC<Props> = ({}) => {
  return (
    <View style={styles.container}>
      <Icon name={'search'} size={80} color={colors.chokuGray8} />
      <Typography
        variant={'h1'}
        text={LocalText.screens.home.notFound.text}
        containerStyle={styles.h1}
      />
      <Typography
        variant={'body'}
        text={LocalText.screens.home.notFound.description}
        containerStyle={styles.body}
        textStyle={styles.bodyText}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 40,
  },
  h1: {
    marginTop: 50,
  },
  body: {
    marginTop: 24,
  },
  bodyText: {
    color: colors.chokuGray5,
    textAlign: 'center',
    lineHeight: 24,
    letterSpacing: 1.2,
  },
});

export default Index;
